import React, { Component } from 'react';
import { Form, Button, Row, Col, Icon, Upload, message, Modal, Tooltip } from 'antd';
import reqwest from 'reqwest';
import fetch from './../services/fetch';

class LicenseForm2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: [],
            loading: false,
        }
    }

    componentDidMount() {
    }

    onSubmit() {
        event.preventDefault();
        if (!this.state.file[0]) {
            message.warn(`请选择许可证文件！`)
            return
        }
        this.setState({
            loading: true
        })
        this.props.form.validateFields((error, values) => {
            const formData = new FormData();
            formData.append('file', this.state.file[0]);
            reqwest({
                url: fetch.base + 'license/install',
                method: 'post',
                processData: false,
                data: formData,
                success: (response) => {
                    const jsonData = JSON.parse(response)
                    if (jsonData.code == 200) {
                        const expireDate = jsonData.payload.data
                        Modal.success({
                            title: '安装许可证成功',
                            content: `安装许可证成功，过期时间为${expireDate}，点击前往登陆！`,
                            onOk: () => {
                                window.location.hash = '/';
                                window.location.reload();
                            }
                        })
                    } else {
                        Modal.error({
                            title: '安装许可证失败！',
                            content: jsonData.message,
                            onOk: () => {
                            }
                        })
                    }
                    setTimeout(() => {
                        this.setState({
                            loading: false
                        })
                    }, 200);
                },
                error: (response) => {
                    Modal.error({
                        title: '安装许可证失败！',
                        content: '安装许可证失败！',
                        onOk: () => {
                        }
                    })
                    setTimeout(() => {
                        this.setState({
                            loading: false
                        })
                    }, 200);
                },
            });

        });
    }

    onRemove(file) {
        this.setState({
            file: []
        });

        this.props.form.resetFields(['file'])
    }

    beforeUpload(file) {
        this.setState(state => ({
            file: [file],
        }));
        return false;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form className="license-form" layout='inline' style={{ padding: '0px 30px' }} onSubmit={this.onSubmit.bind(this)}>
                <Row span={24}>
                    <Col offset={4}>
                        <Form.Item label="许可证文件">
                            {
                                getFieldDecorator('file', {
                                    initialValue: '',
                                    rules: [{
                                        required: true,
                                        message: '请选择许可证文件',
                                    }],
                                })(
                                    <Upload beforeUpload={this.beforeUpload.bind(this)} onRemove={this.onRemove.bind(this)} fileList={this.state.file}>
                                        <Button style={{ width: 180 }}>
                                            <Icon type="upload" />请选择许可证文件
                                        </Button>
                                        <span style={{ marginLeft: 10 }}>
                                            <Tooltip
                                                placement="topLeft"
                                                title={
                                                    <span>
                                                        <p>
                                                            许可证是通过上面 “生成许可证” 按钮获取！
                                                        </p>
                                                    </span>
                                                }
                                            >
                                                <Icon type="question-circle" />
                                                &nbsp;
                                            </Tooltip>
                                        </span>
                                    </Upload>
                                )
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col offset={6}>
                        <Button style={{ width: '60%', margin: '0 auto', width: 260 }} loading={this.state.loading} size="large" htmlType="submit" type="primary">注册</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default Form.create()(LicenseForm2);
